<template>
<transition name="el-fade-in-linear">
    <el-card class="uploader-file-item" shadow="always" style="margin-top: 10px;" body-style="padding: 10px;" @mouseover.native="onMouseOver" @mouseleave.native="onMouseOut">
        <!-- <label v-if="status" class="item-status-label">
                <i class="el-icon-check status-icon"></i>
            </label> -->
        <i class="el-icon-delete close" style="color: red;" v-show="active && editable" @click="$emit('file-delete', file)"></i>
        <div slot="header" class="clearfix">
            <span>{{file.name}}</span>
            <el-button v-show="editable" style="float: right; padding: 3px 0; font-size: 9pt;" type="text" @click="rename">Rename</el-button>
            <!-- <el-button style="float: right; padding: 3px 0" type="text">Delete</el-button> -->
        </div>
        <el-row class="file-info">
            <el-col :span="4">
                <img :src="file.url" alt="" class="file-thumbnail" />
                </el-col>
                <el-col :span="20">
                    <el-tag v-if="!isFileNameValid" class="attribute-tag" type="danger">Invalid file name. Please rename file.</el-tag>
                    <div v-else>
                        <el-tag class="attribute-tag" type="success">{{file.entityName}}</el-tag>
                        <el-tag class="attribute-tag" type="warning">{{file.task}}</el-tag>
                        <el-tag v-if="file.descriptor" class="attribute-tag" type="info">{{file.descriptor}}</el-tag>
                        <el-tag class="attribute-tag" type="default">{{file.version}}</el-tag>
                    </div>
                </el-col>
                <i class="el-icon-loading" v-if="uploading" style="color: #13ce66; font-size:19pt"></i>
                <!-- <el-progress v-if="uploading" type="circle" :status="status" :percentage="percentageUploaded" :width="40" :stroke-width="4"></el-progress> -->
                <div v-else>
                    <i v-if="status=='success'" class="el-icon-circle-check" style="color: #13ce66; font-size:24pt"></i>
                    <el-tag v-else-if="readyToUpload" size="small" type="success" style="border-radius: 7px; margin-left: 10px">ready</el-tag>
                    <el-tag v-else-if="isFileNameValid" size="small" type="danger" style="border-radius: 7px; margin-left: 10px">no record</el-tag>
                </div>
        </el-row>
    </el-card>
</transition>
</template>

<script>
import {
    findAssetOrShotByName,
    findTaskByName,
    createVersionEntity,
    uploadToShotgun
} from "@/api";

export default {
    name: "FileItem",
    props: {
        editable: Boolean,
        file: Object
    },
    data() {
        return {
            active: false,
            isFileNameValid: false,
            readyToUpload: false,
            // Upload status
            status: null,
            uploading: false,
            error: null
        };
    },
    computed: {
        percentageUploaded() {
            return this.file.percentage;
        }
    },
    created() {
        this.$parent.$on("startUpload", this.startUpload);
    },
    methods: {
        onMouseOver: function () {
            this.active = true;
        },
        onMouseOut: function () {
            this.active = false;
        },
        rename: function () {
            const renamePromptOptions = {
                inputValue: this.file.name
            };
            this.$prompt(
                    "Please enter a new name:",
                    "Rename File",
                    renamePromptOptions
                )
                .then(({
                    value
                }) => {
                    if (!value) {
                        return false;
                    }
                    this.$message.success("file renamed successfully.");
                    this.file.name = value;
                })
                .catch(() => {});
        },
        validateFileName() {
            // <entityName>_<task>(<_descriptor>)_v[###].<extension>
            const regexPattern = /^([A-Z.]+_)?([a-zA-Z_0-9]+)_([A-Z]{3})(_([a-zA-Z_0-9.]+))?_([vV][0-9.]+)(\.[a-zA-Z0-9]+)$/;
            const isValid = regexPattern.test(this.file.name);
            if (isValid) {
                [, ,
                    this.file.entityName,
                    this.file.task, ,
                    this.file.descriptor,
                    this.file.version, ,
                ] = regexPattern.exec(this.file.name);
            }
            this.isFileNameValid = isValid;
        },
        findAssetData: function () {
            // first find asset
            findAssetOrShotByName(this.file.entityName)
                .then(entityData => {
                    this.file.entityData = entityData;
                    // then find the task for this asset
                    return findTaskByName(entityData, this.file.task);
                })
                .then(taskData => {
                    // if both are found, get the upload Link
                    this.file.taskData = taskData;
                    this.readyToUpload = true;
                })
                .catch(error => {
                    this.error = error;
                    this.readyToUpload = false;
                    this.file.entityData = null;
                    this.file.taskData = null;
                });
        },
        updateProgress: function (progressEvent) {
            this.file.percentage = (100 * progressEvent.loaded) / progressEvent.total;
        },
        startUpload() {
            if (!this.readyToUpload || this.uploading) return;
            this.uploading = true;
            createVersionEntity(
                    this.file.name,
                    this.file.entityData,
                    this.file.taskData
                )
                .then(res => {
                    this.file.versionData = res.data.data;
                    return uploadToShotgun(
                        this.file.versionData,
                        this.file,
                        this.uploadProgress
                    );
                })
                .then(res => {
                    console.log(res);
                    this.status = "success";
                    this.uploading = false;
                    this.$eventBus.$emit("upload-success", this.file);
                })
                .catch(error => {
                    this.error = error;
                    this.status = "exception";
                    this.$eventBus.$emit("upload-failure", this.file);
                });
        }
    },
    watch: {
        // when file name becomes valid, get an upload link from shotgun
        file: {
            immediate: true,
            deep: true,
            handler: function () {
                this.validateFileName();
                if (this.isFileNameValid) this.findAssetData();
                else {
                    this.readyToUpload = false;
                }
            }
        },
        readyToUpload: {
            immediate: true,
            handler: function (val) {
                this.file.status = val ? "ready" : "invalid";
            }
        }
    }
};
</script>

<style>
.uploader-file-item .el-card__header {
    padding: 14px 20px;
}
</style>

<style scoped>
.uploader-file-item {
    border-radius: 8px;
    border: none;
    position: relative;
    /* background-color: #f5f5f5aa; */
    transition: all 0.5s cubic-bezier(0.55, 0, 0.1, 1);
}

.item-status-label {
    display: block;
    position: absolute;
    right: -17px;
    top: -7px;
    height: 26px;
    width: 46px;
    text-align: center;
    background: #13ce66;
    transform: rotate(45deg);
    box-shadow: 0 1px 1px #ccc;
}

.status-icon {
    color: white;
    margin-top: 12px;
    font-size: 12px;
    transform: rotate(-45deg);
}

.close {
    position: absolute;
    top: 5px;
    right: 5px;
    cursor: pointer;
    opacity: 0.75;
    color: #606266;
}

.file-info {
    display: flex;
    align-items: center;
}

.clearfix {
    position: relative;
}

.clearfix:before,
.clearfix:after {
    display: table;
    content: "";
}

.clearfix:after {
    clear: both;
}

.file-thumbnail {
    width: 40px;
    height: 40px;
    border-radius: 5px;
}

.attribute-tag {
    margin-right: 5px;
}
</style>
